import { SignalRActionTypes, SignalRTypes } from "./signalRTypes";

export function signalRConnect(): SignalRActionTypes {
	return {
		type: SignalRTypes.SIGNALR_CONNECT,
	};
}

export function signalRDisconnect(): SignalRActionTypes {
	return {
		type: SignalRTypes.SIGNALR_DISCONNECT,
	};
}

export function signalRUserConnected(): SignalRActionTypes {
	return {
		type: SignalRTypes.SIGNALR_USER_CONNECTED,
	};
}

export function signalRReceiveUpdates<T>(content: T) {
	return {
		type: SignalRTypes.SIGNALR_RECEIVE_UPDATES,
		payload: { content },
	};
}

export function signalRClearReceiveUpdatesByKey(key: number): SignalRActionTypes {
	return {
		type: SignalRTypes.SIGNALR_CLEAR_RECEIVE_UPDATES_BYKEY,
		payload: { key },
	};
}

export function signalRClearAllReceiveUpdates(): SignalRActionTypes {
	return {
		type: SignalRTypes.SIGNALR_CLEAR_ALL_RECEIVE_UPDATES,
	};
}
